import { Tooltip } from '@mui/material'
import { MetroSpinner } from 'react-spinners-kit'

import DropdownActionButtonMui from '../../../../components/action_button/DropdownActionButtonMui'
import {
  SENDABLE_STATUSES,
  REJECTABLE_STATUSES
} from '../../constants/ocConstants'
import { canReprocessOrder } from '../../helpers/ocHelpers'
import { canManagePocOrders } from '../../../../global_context/capabilities/pocCapabilities'
import { valueOrDash, formatPercent } from '../../helpers/tableUtils'

const renderTooltipText = (value, { uppercase = false } = {}) => {
  const resolvedValue = valueOrDash(value)

  if (resolvedValue === '-') return '-'

  const label = uppercase
    ? String(resolvedValue).toUpperCase()
    : String(resolvedValue)

  return (
    <Tooltip title={label} arrow placement="top" enterDelay={300}>
      <span className="oc-cell-ellipsis">{label}</span>
    </Tooltip>
  )
}

const OcOrdersRow = ({
  model,
  statusUiMap,
  onSend,
  onReject,
  onReprocess,
  sendingIds
}) => {
  const canWrite = canManagePocOrders()

  const statusKey = model.status
  const isSending = sendingIds?.has(model.id) === true
  const isErrorLike = statusKey === 'error' || statusKey === 'rejected'
  const isIgnored = model.is_ignored === true

  const canOpen =
    !isSending &&
    (
      (!isErrorLike && model.order_id) ||
      (isErrorLike && model.db_ref)
    )

  const clientLabel = (model.client_uid || model.client_name)
    ? `${valueOrDash(model.client_uid)} - ${valueOrDash(model.client_name)}`
    : '-'

  const userLabel = (model.user_uid || model.user_name)
    ? `${valueOrDash(model.user_uid)} - ${valueOrDash(model.user_name)}`
    : '-'

  const actions = []

  if (canWrite && !isSending) {
    const canSend =
      model.send_to_erp === true &&
      SENDABLE_STATUSES.includes(statusKey)

    const canReject =
      REJECTABLE_STATUSES.includes(statusKey) &&
      !isIgnored

    const canReprocess = canReprocessOrder({
      status: statusKey,
      processed_lines_percentage: model.processed_lines_percentage,
      is_ignored: model.is_ignored
    })

    if (canSend) {
      actions.push({
        text: 'Enviar',
        handler: () => onSend(model)
      })
    }

    if (canReject) {
      actions.push({
        text: 'Rechazar',
        handler: () => {
          const confirmed = window.confirm(
            '¿Deseas rechazar esta orden?'
          )
          if (!confirmed) return
          onReject(model)
        }
      })
    }

    if (canReprocess) {
      actions.push({
        text: 'Reprocesar',
        handler: () => onReprocess(model)
      })
    }
  }

  const openOrder = () => {
    if (!canOpen) return

    const path = isErrorLike
      ? `/ordenes_oc_details/${encodeURIComponent(model.id)}/error`
      : `/ordenes_oc_details/${encodeURIComponent(model.order_id)}`

    window.open(path, '_blank', 'noopener,noreferrer')
  }

  return (
    <tr
      className={canOpen ? 'cursor-pointer' : ''}
      onClick={canOpen ? openOrder : undefined}
    >
      <td>{valueOrDash(model.formatted_date)}</td>
      <td className="oc-td-text">
        {renderTooltipText(model.db_ref)}
      </td>

      <td className="oc-td-text">
        {renderTooltipText(clientLabel, { uppercase: true })}
      </td>

      <td className="oc-td-center">
        {formatPercent(model.processed_lines_percentage)}
      </td>

      <td>
        {!isSending && !isErrorLike && model.order_id ? (
          <span
            className="link-primary text-decoration-underline"
            onClick={(e) => {
              e.stopPropagation()
              openOrder()
            }}
          >
            VER PEDIDO
          </span>
        ) : (
          '-'
        )}
      </td>

      <td className="oc-td-text">
        {renderTooltipText(model.sales_order_number)}
      </td>

      <td className="oc-td-text">
        {renderTooltipText(userLabel, { uppercase: true })}
      </td>

      <td className="oc-td-text">
        {statusKey === 'error'
          ? renderTooltipText(model.details, { uppercase: true })
          : '-'}
      </td>

      <td>
        {isSending ? (
          <div className="td-delivery-status">
            <MetroSpinner size={20} color="#747474" />
            <span className="saving-route-box-title">Validando...</span>
          </div>
        ) : statusUiMap[statusKey] ? (
          <div className="td-delivery-status">
            <div className={`delivery-status ${statusUiMap[statusKey].className}`}>
              {statusUiMap[statusKey].label}
            </div>
          </div>
        ) : (
          '-'
        )}
      </td>

      <td
        className={`oc-action-cell action-wrapper ${actions.length === 0 ? 'disabled' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <DropdownActionButtonMui
          id={`btn-dropdown-${model.order_id ?? `${model.id}-error`}`}
          list={actions}
        />
      </td>
    </tr>
  )
}

export default OcOrdersRow
